// Helper functions for localStorage with 24-hour expiration
function getLocalStorageWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;
  
  // Handle old format (just 'true' string) - treat as expired
  if (itemStr === 'true') {
    localStorage.removeItem(key);
    return null;
  }
  
  try {
    const item = JSON.parse(itemStr);
    const now = new Date().getTime();
    
    // Check if item is expired (older than 24 hours = 86400000 ms)
    if (now - item.timestamp > 86400000) {
      localStorage.removeItem(key);
      return null;
    }
    
    return item.value;
  } catch (e) {
    // If parsing fails, treat as expired and remove
    localStorage.removeItem(key);
    return null;
  }
}

function setLocalStorageWithExpiry(key, value) {
  const item = {
    value: value,
    timestamp: new Date().getTime()
  };
  localStorage.setItem(key, JSON.stringify(item));
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
      // Store which button is clicked before form submission
      const submitButtons = this.querySelectorAll('[type="submit"]');
      submitButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          this.submitButton = button;
        });
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.submitButton.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log('routes.cart_add_url', routes.cart_add_url);
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.addExtaProductsForEachCartItems();
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const spinner = this.submitButton.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }


    async getCart() {
      return fetch('/cart.js')
      .then(response => response.json())
      .catch(error => {
          console.error('Error fetching cart:', error);
      });
    }

   
  
    async isProductInProductTypes(handle, categoryNames) {
      const response = await fetch(`/products/${handle}.json`);
      const data = await response.json();
      return data.product.tags.includes(categoryNames);
    }
  
    // Add products for each product in the "velos" category that is in the cart
    async addExtaProductsForEachCartItems() {
      
      let cart = await this.getCart();
      let cartItems = cart.items;
      
  
    
      for (const item of cartItems) {
        if (await this.isProductInProductTypes(item.handle, 'Marquage')) {
          const cartItem = document.querySelector(`.cart-item[data-product-id="${item.product_id}"]`);
          if (!getLocalStorageWithExpiry(`extraProductsAddedFor${item.product_id}`)) {
            console.log('local storage extraProductsAddedFor', item.product_id, ' does not exist');
  
            console.log('so adding extra products variant', extraProduct1VariantId, extraProduct1VariantId, 'to cart for', item.id);
            await this.addExtraProductVariantToCart([extraProduct1VariantId, extraProduct2VariantId], cartItem);
            
  
            console.log('and setting local storage item for', item.product_id)
            setLocalStorageWithExpiry(`extraProductsAddedFor${item.product_id}`, 'true');
          }
        }
      }
    }
  
  
      
  
    async addExtraProductVariantToCart(variantIds, cartItem) {
  
        this.handleErrorMessage();
        const config = fetchConfig('javascript');
        config.headers['Content-Type'] = 'application/json';

        console.log('variantIds', variantIds);
  
        let itemsToAdd = [];

        variantIds.forEach(variantId => {
            if (variantId) {
                itemsToAdd.push({ id: variantId, quantity: 1 });
            }
        });
  
        let data = {
          'items': itemsToAdd
        };

        console.log('data', data);  
  
        config.body = JSON.stringify(data);
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            return response.json()
          })
          .then((response) => {
            console.log('response', response.json)
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            } 
            console.log(`Variant ${variantIds} added to cart`);
            this.error = false; 
            // if we could add bikes from the cart page we would need to rerender the cart items
            // this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
            cartItem.insertAdjacentHTML('afterend', '<td class="cart-item__extra-products-wrapper"><p class="error-message">Failed to add product to cart</p></td>');
          });
    }
  });
}
